import axios from 'axios'
import Constantes from '../../utils/constantes'
import Alert from '../../utils/alert'
import router from '../../router/index'

const state = {
    p: null,
    usuarioLogado: null,
    user: null,
    config: null,
    funcionarioResponsavel: null,
    token: null,
    clienteNovo: {
        cliIntCod: -1,
        cliStrNme: '',
        cliStrDocumento: '',
        cliStrEndereco: '',
        cliStrBairro: '',
        cliStrCidade: '',
        cliChaUf: '',
        cliChaCep: '',
        cliChaFone1: '',
        cliStrLogin: '',
        empresa: {
            empIntCod: null,
        }
    },
    cepFrete: "",
    menu: []
}

// getters
const getters = {
    usuarioLogado(state) {
        return state.usuarioLogado
    },
    user(state) {
        return state.user
    },
    orcamento(state) {
        return state.config ? state.config.emcChaB2COrcamento === 'S' : null
    },
    config(state) {
        return state.config
    },
    funcionarioResponsavel(state) {
        return state.funcionarioResponsavel
    },
    clienteNovo(state) {
        return state.clienteNovo
    },
    clienteLogado(state) {
        return state.user != null
    },
    token(state) {
        return state.token.split(' ')[1]
    },
    cepFrete(state) {
        return state.cepFrete;
    },
    menu(state) {
        return state.menu;
    }
}

function createItensMenu(menu) {
    function buildTree(items, parentId) {
        const tree = [];

        for (const item of items) {
            if (item.nivel === 1 && item.hasFilho) {
                // Ignora os itens de nível 1 com filhos, continue para os filhos.
                tree.push(...buildTree(item.filhos, parentId));
            } else {
                const newItem = {
                    //id: item.codFabricante || item.caiIntCod, // Usar codFabricante se disponível, caso contrário, use caiIntCod
                    id: item.caiIntCod,
                    name: item.caiStrNome,
                    pai: item.caiStrNomePai,
                    children: [],
                };

                if (item.hasFilho && item.filhos.length > 0) {
                    newItem.children = buildTree(item.filhos, item.caiIntCod);
                }

                tree.push(newItem);
            }
        }

        return tree;
    }

    return buildTree(menu, null);
}

function insertEstrutura(itensMenu, menu) {
    for (const menuItem of menu) {
        if (!menuItem.estrutura) {
            menuItem.estrutura = []; // Inicialize o campo estrutura se não existir
        }

        for (const itemMenu of itensMenu) {
            if (itemMenu.pai === menuItem.caiStrNome) {
                // Se encontrarmos correspondência, adicione ao campo estrutura
                menuItem.estrutura = [...menuItem.estrutura, itemMenu];
            }
        }

        if (menuItem.filhos.length > 0) {
            if (menuItem.filhos[0].filhos.length > 0)
                menuItem.umNivel = false
            else
                menuItem.umNivel = true
        }
    }
    return menu;
}

// actions
const actions = {
    carregarParametroFiltro({ commit, getters }, payload) {
        if (payload.p) {
            commit('setP', payload.p)
        }
    },
    removerParametroFiltro({ commit, getters }, payload) {
        commit('setP', null)
    },
    removeUserOutraLoja({ commit, getters }, payload) {
        if (getters.user && getters.user.empresa.empIntCod !== parseInt(payload.empIntCod)) {
            commit('setToken', null)
            commit('setUser', null)
        }
    },
    esqueciMinhaSenha({ commit, dispatch }, payload) {
        commit('core/setLoading', true, { root: true })
        commit('core/clearError', null, { root: true })
        commit('chat/setMensagens', [], { root: true })
        axios({
            method: 'POST',
            url: Constantes.URL_SERVIDOR + '/cliente/esquecisenha',
            data: { busStrLogin: payload.busStrLogin, empIntCod: payload.empIntCod }
        }).then(
            result => {
                if (result.data !== '') {
                    commit('core/setSuccess', { message: result.data }, { root: true })
                }
                commit('core/setLoading', false, { root: true })
            },
            error => {
                commit('core/setLoading', false, { root: true })
                commit('core/setError', { message: 'Erro ao solicitar a senha.' }, { root: true })
            }
        )
    },
    login({ commit, dispatch }, payload) {
        commit('core/setLoading', true, { root: true })
        commit('core/clearError', null, { root: true })
        commit('chat/setMensagens', [], { root: true })

        axios({
            method: 'POST',
            url: Constantes.URL_SERVIDOR + '/login',
            data: { login: `${payload.cliente}:${payload.empIntCod}:`, senha: payload.senha }
        }).then(
            result => {
                if (result.data !== '') {
                    commit('setToken', result.headers.authorization)
                    commit('setUsuarioLogado', result.data)
                    commit('setUser', result.data.cliente)
                    dispatch('pedido/removeItensCarrinhoOutraLoja', { empIntCod: payload }, { root: true })
                    dispatch('carregarFuncionarioResponsavel', result.data.cliente.cliIntCod)
                    dispatch('carregarConfig', result.data.cliente.empresa.empIntCod)
                } else {
                    commit('core/setError', { message: 'Usuário/Senha inválidos.' }, { root: true })
                }
                commit('core/setLoading', false, { root: true })

                const url = new URL(window.location.href);

                const menuCatalogo = url.searchParams.get('menuCatalogo');

                if (menuCatalogo === 'true') {
                    axios({
                        method: 'GET',
                        url: `${Constantes.URL_SERVIDOR}/catalogo/itens-menu?empIntCod=${payload.empIntCod}`,
                        headers: { 'Authorization': `Bearer ${result.headers.authorization}` }
                    }).then(
                        result => {                            
                            let menuAgora = result.data;
                            let itensMenu = createItensMenu(menuAgora, null, 1);

                            let novoMenu = insertEstrutura(itensMenu, menuAgora);
                            commit('setMenu', novoMenu)
                        },
                        error => {
                            console.error(error)
                            commit('core/setError', error, { root: true })
                        }
                    )
                } else {
                    commit('setMenu', [])
                }
            },
            error => {
                commit('core/setLoading', false, { root: true })
                commit('core/setError', { message: 'Usuário/Senha inválidos.' }, { root: true })
            }
        )
    },
    loginurl({ commit, dispatch }, payload) {
        return new Promise((resolve, reject) => {
            commit('core/setLoading', true, { root: true })
            commit('core/clearError', null, { root: true })
            commit('chat/setMensagens', [], { root: true })
            axios({
                method: 'POST',
                url: Constantes.URL_SERVIDOR + '/b2cusuario/loginurl',
                data: { busIntCod: payload.u, busStrSenha: payload.s }
            }).then(
                result => {
                    if (result.data !== '') {
                        commit('setToken', result.headers.authorization)
                        commit('setUsuarioLogado', result.data)
                        commit('setUser', result.data.cliente)
                        dispatch('pedido/removeItensCarrinhoOutraLoja', { empIntCod: payload }, { root: true })
                        dispatch('carregarFuncionarioResponsavel', result.data.cliente.cliIntCod)
                        dispatch('carregarConfig', result.data.cliente.empresa.empIntCod)
                        resolve(result.data);
                    } else {
                        commit('core/setError', { message: 'Usuário/Senha inválidos.' }, { root: true })
                    }
                    commit('core/setLoading', false, { root: true })
                },
                error => {
                    reject(error);
                    commit('core/setLoading', false, { root: true })
                    commit('core/setError', { message: 'Usuário/Senha inválidos.' }, { root: true })
                }
            )
        })
    },
    criarcliente({ commit }, payload) {
        return new Promise((resolve, reject) => {
            commit('core/setLoading', true, { root: true })
            commit('core/clearError', null, { root: true })
            axios({
                method: 'POST',
                url: Constantes.URL_SERVIDOR + '/cliente/criar',
                data: payload
            }).then(
                result => {
                    if (result.data !== '') {
                        resolve(result.data);
                        if (result.data.tipo === 'sucesso') {
                            commit('limpaClienteNovo')
                        }
                    } else {
                        commit('core/setError', { message: 'Usuário/Senha inválidos.' }, { root: true })
                    }
                    commit('core/setLoading', false, { root: true })
                },
                error => {
                    commit('core/setLoading', false, { root: true })
                    commit('core/setError', { message: 'Erro' }, { root: true })
                    reject(error);
                }
            )
        })
    },
    alterarcliente({ commit }, payload) {
        return new Promise((resolve, reject) => {
            commit('core/setLoading', true, { root: true })
            commit('core/clearError', null, { root: true })
            axios({
                method: 'POST',
                url: Constantes.URL_SERVIDOR + '/cliente/alterar',
                data: payload
            }).then(
                result => {
                    resolve(result.data);
                    commit('core/setSuccess', { message: 'Atualização realizada com sucesso.' }, { root: true })
                    commit('core/setLoading', false, { root: true })
                },
                error => {
                    commit('core/setLoading', false, { root: true })
                    commit('core/setError', { message: 'Erro' }, { root: true })
                    reject(error);
                }
            )
        })
    },
    trocarsenha({ commit }, payload) {
        if (payload.senha2 !== payload.senha3) {
            commit('core/setError', { message: 'Senha nova não é a mesma da senha de confirmação.' }, { root: true })
            return
        }
        if (payload.senha2 === '' || payload.senha3 === '') {
            commit('core/setError', { message: 'Senha não pode ser vazia.' }, { root: true })
            return
        }
        commit('core/setLoading', true, { root: true })
        commit('core/clearError', null, { root: true })
        axios({
            method: 'POST',
            url: Constantes.URL_SERVIDOR + '/cliente/trocarsenha',
            data: payload
        }).then(
            result => {
                if (result.data !== '') {
                    commit('core/setSuccess', { message: result.data }, { root: true })
                }
                commit('core/setLoading', false, { root: true })
            },
            error => {
                commit('core/setLoading', false, { root: true })
                commit('core/setError', { message: 'Erro ao trocar senha.' }, { root: true })
            }
        )

    },
    trocarFoto({ commit, getters }, payload) {
        commit('core/setLoading', true, { root: true })
        commit('core/clearError', null, { root: true })
        axios({
            method: 'POST',
            url: Constantes.URL_SERVIDOR + '/cliente/trocarFoto',
            data: { foto: payload, cliente: getters.user }
        }).then(
            result => {
                if (result.data !== '') {
                    commit('setUser', result.data)
                    commit('core/setLoading', false, { root: true })
                } else {
                    commit('core/setError', { message: 'Erro ao enviar Foto.' }, { root: true })
                }
                commit('core/setSuccess', { title: 'Imagem alterada!' }, { root: true })
            },
            error => {
                commit('core/setLoading', false, { root: true })
                commit('core/setError', error, { root: true })
            }
        )
    },
    procurarCliente({ commit }, payload) {
        commit('core/setLoading', true, { root: true })
        commit('core/clearError', null, { root: true })
        axios({
            method: 'GET',
            url: `${Constantes.URL_SERVIDOR}/cliente/procurarPorDocumento?cliStrDocumento=${payload.cliStrDocumento}&empIntCod=${payload.empIntCod}`
        }).then(
            result => {
                if (result.data !== '') {
                    commit('setClienteNovo', result.data)
                } else {
                    commit('limparCliente', payload.cliStrDocumento)
                }
                commit('core/setLoading', false, { root: true })
            },
            error => {
                commit('core/setLoading', false, { root: true })
                commit('core/setError', error, { root: true })
            }
        )
    },
    procurarCEP({ state, commit }, payload) {
        commit('core/setLoading', true, { root: true })
        commit('core/clearError', null, { root: true })
        axios({
            method: 'GET',
            url: 'https://viacep.com.br/ws/' + payload + '/json/'
        }).then(
            result => {
                if (result.data !== '') {
                    if (!state.user || state.user.cliChaCep === "") {
                        commit('setEnderecoclienteNovo', result.data)
                    } else {
                        commit('setEnderecoNovoUser', result.data)
                    }
                }
                commit('core/setLoading', false, { root: true })
            },
            error => {
                commit('core/setLoading', false, { root: true })
                commit('core/setError', error, { root: true })
            }
        )
    },
    logout({ commit, dispatch }) {
        commit('setUser', null)
        commit('setToken', null)
        commit('setFuncionarioResponsavel', null)
        dispatch("pedido/tipoEntrega", null, { root: true });
        commit("pedido/setValorFrete", true, { root: true });
        commit("empresa/setFilial", null, { root: true });
        commit('anuncio/setFiltroCatalogo', null, { root: [] });
        commit('setMenu', [])
    },
    carregarFuncionarioResponsavel({ commit }, payload) {
        commit('core/clearError', null, { root: true })
        axios({
            method: 'GET',
            url: `${Constantes.URL_SERVIDOR}/cliente/procurarFuncionarioResponsavel?cliIntCod=${payload}`
        }).then(
            result => {
                if (result.data !== '') {
                    commit('setFuncionarioResponsavel', result.data)
                } else {
                    commit('setFuncionarioResponsavel', null)
                }
            },
            error => {
                commit('core/setError', error, { root: true })
            }
        )
    },
    carregarConfig({ commit }, payload) {
        commit('core/clearError', null, { root: true })
        axios({
            method: 'GET',
            url: `${Constantes.URL_SERVIDOR}/empresa/config?empIntCod=${payload}`
        }).then(
            result => {
                if (result.data !== '') {
                    commit('setConfig', result.data)
                } else {
                    commit('setConfig', null)
                }
            },
            error => {
                console.error(error)
                commit('core/setError', error, { root: true })
            }
        )
    },

    procurarCEPUsuarioLogado({ commit, dispatch }, payload) {
        commit('core/setLoading', true, { root: true })
        commit('core/clearError', null, { root: true })
        axios({
            method: 'GET',
            url: 'https://viacep.com.br/ws/' + payload + '/json/'
        }).then(
            result => {
                if (result.data !== '') {
                    commit('setEnderecoUsuarioLogado', result.data)
                }
                commit('core/setLoading', false, { root: true })
            },
            error => {
                commit('core/setLoading', false, { root: true })
                commit('core/setError', error, { root: true })
            }
        )
    },

    procurarCEPFrete({ commit, dispatch }, payload) {
        commit('core/setLoading', true, { root: true })
        commit('core/clearError', null, { root: true })
        axios({
            method: 'GET',
            url: 'https://viacep.com.br/ws/' + payload + '/json/'
        }).then(
            result => {
                if (result.data !== '') {
                    commit('setEnderecoFrete', result.data)
                }
                commit('core/setLoading', false, { root: true })
            },
            error => {
                commit('core/setLoading', false, { root: true })
                commit('core/setError', error, { root: true })
            }
        )
    },
}

// mutations
const mutations = {
    setP(state, payload) {
        state.p = payload
    },
    setConfig(state, payload) {
        state.config = payload
    },
    setUsuarioLogado(state, payload) {
        state.usuarioLogado = payload
    },
    setUser(state, payload) {
        state.user = payload
    },
    setFuncionarioResponsavel(state, payload) {
        state.funcionarioResponsavel = payload
    },
    setToken(state, payload) {
        state.token = payload
    },
    setClienteNovo(state, payload) {
        state.clienteNovo = payload
    },
    setEnderecoclienteNovo(state, payload) {
        state.clienteNovo.cliStrEndereco = payload.logradouro
        state.clienteNovo.cliStrBairro = payload.bairro
        state.clienteNovo.cliStrCidade = payload.localidade
        state.clienteNovo.cliChaUf = payload.uf
    },
    setEnderecoNovoUser(state, payload) {
        state.user.cliStrEndereco = payload.logradouro
        state.user.cliStrBairro = payload.bairro
        state.user.cliStrCidade = payload.localidade
        state.user.cliChaUf = payload.uf
    },
    setEnderecoUsuarioLogado(state, payload) {
        state.usuarioLogado.busStrEndereco = payload.logradouro
        state.usuarioLogado.busStrBairro = payload.bairro
        state.usuarioLogado.busStrCidade = payload.localidade
        state.usuarioLogado.busChaUf = payload.uf
    },
    setEnderecoFrete(state, payload) {
        state.cepFrete = payload
    },
    limpaClienteNovo(state) {
        const cn = {
            cliIntCod: -1,
            cliStrNme: '',
            cliStrDocumento: '',
            cliStrEndereco: '',
            cliStrBairro: '',
            cliStrCidade: '',
            cliChaUf: '',
            cliChaCep: '',
            cliChaFone1: '',
            cliStrLogin: '',
            empresa: {
                empIntCod: null,
            }
        }
        state.clienteNovo = cn
    },
    limparCliente(state, payload) {
        const cn = {
            cliIntCod: -1,
            cliStrNme: '',
            cliStrDocumento: payload,
            cliStrEndereco: '',
            cliStrBairro: '',
            cliStrCidade: '',
            cliChaUf: '',
            cliChaCep: '',
            cliChaFone1: '',
            cliStrLogin: '',
            empresa: {
                empIntCod: null,
            }
        }
        state.clienteNovo = cn
    },
    setMenu(state, payload) {
        state.menu = payload
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}